import { browser_regex_default } from "./browser-regex-s2ET8FOl.mjs";

//#region src/isBrowserSupported.ts
/**
* Checks if a user-agent string is in the list of supported browsers.
*
* Run yarn update-supported-browsers to update the list of browsers for this function.
* This update should be done at the same time that we update browerslist.
*
* @private
* @deprecated
*/
const isBrowserSupported = (userAgent) => browser_regex_default.test(userAgent);
var isBrowserSupported_default = isBrowserSupported;

//#endregion
export { isBrowserSupported_default };